import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiRepository } from '@softline/core';
import { SOFTLINE_API_ABC_ANALYSIS_SEGMENTS } from '../abc-analysis.api';
import { AbcAnalysisSegmentDefinitionsResult } from '../types/abc-analysis-segment-definition';

@Injectable()
export class AbcAnalysisSegmentsRepository extends ReadonlyHttpApiRepository<
  AbcAnalysisSegmentDefinitionsResult,
  { abcAnalysisId: number }
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_SEGMENTS);
  }

  protected override getLoadPathParams(params: {
    abcAnalysisId: number;
  }): Dictionary<unknown> | undefined {
    return { abcAnalysisId: params.abcAnalysisId };
  }
}
